module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_05-a33ea43ab1957a7ecda0866af96adbf2.png";